<script setup lang="ts">
import IconFaq from "~/components/AppFaq/icons/IconFaq.vue";
import IconArrow from "~/components/AppFaq/icons/IconArrow.vue";

const showAll = ref(false);

interface Item {
  id: number;
  question: string;
  answer: string;
}

const props = defineProps<{
  id: number;
  title: string;
  show_number: number;
  faq_cards: Item[];
}>();

const displayedFaqs = computed(() => showAll.value ? props.faq_cards : props.faq_cards.slice(0, props.show_number));
const isAllShown = computed(() => showAll.value || props.show_number >= props.faq_cards.length)
const openFaqItem = ref<number | null>(null);
const openedFaqs = reactive<{ [key: number]: boolean }>({});

const toggleItem = (index: number) => {
  if (!openedFaqs[index]) {
    openedFaqs[index] = true;
  }
  openFaqItem.value = openFaqItem.value === index ? null : index;
};
const toggleShowAll = () => {
  showAll.value = !showAll.value;
};
</script>

<template>
  <section class="faq section-offset">
    <div class="container">
      <h3 class="faq__title">
        {{ props.title }}
      </h3>
      <div class="faq__wrapper">
        <div
            v-for="(item, index) in displayedFaqs"
            :key="index"
            class="faq__item"
            @click="toggleItem(index)"
        >
          <h4 class="faq__item-title">
            <IconFaq :is-open="openFaqItem === index"/>
            {{ item.question }}
          </h4>
          <transition name="fade">
            <div v-show="openFaqItem === index" class="faq__item-description">
              <div @click.stop v-html="item.answer"></div>
            </div>
          </transition>
        </div>
        <button
            v-if="!isAllShown"
            class="dc-link-button"
            @click="toggleShowAll"
        >
          <IconArrow/>
          <span>{{ $t('main.faqs.more.button') }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<style>
@import "./AppFaq.scss";
</style>
